const categorySc = [
  "法律服务",
  "会计及税务",
  "知识产权",
  "金融服务",
  "跨境贸易争端护航计划 (1 小时免费法律咨询)",
  '检测及认证',
  '市场推广服务',
  // "商业服务",
  // "银行",
  // "保险",
  // "影视行业",
];

export default categorySc;
